import useMediaQuery from '@mui/material/useMediaQuery';
export default useMediaQuery;
